// src/data/serumsImg/hydroImages.js

export const hydroImages = {
  imgBanner: require("../../img/jetCare-serums/Opening_pages_Hydro.png"),
  imgModal: require("../../img/jetCare-serums/Water.png"),
  productsImages: {
    "jetCare-hydro": {
      image: require("../../img/jetCare-serums/Water.png"),
      imageBig: require("../../img/jetCare-serums/HydroBig.png"),
    }
  }
};
